<template>
    <el-row :gutter="gutter">
        <el-col v-for="(item, index) in newVideo" :key="rowKey ? item[rowKey] : index"
            :span="setSpan ? setSpan(item, index) : span">
            <slot :row="item" :index="index" :disabled="setDisabled(item)" />
        </el-col>
    </el-row>
</template>
  
<script>
export default {
    name: 'BaseVideoGrid',

    props: {
        videos: {
            type: Array,
            default: () => []
        },
        gutter: {
            type: Number,
            default: 20
        },
        span: {
            type: Number,
            default: 6
        },
        rowKey: String,
        srcKey: String,
        exclude: {
            type: Array,
            default: () => ['no_photo']
        },
        setSpan: Function,
        url: [String, Function]
    },
    data() {
        return {
            newVideo: []
        }
    },

    computed: {
    },

    watch: {
        videos(val) {
            this.newVideo = []
            this.$nextTick(() => {
                this.newVideo = val
            })
        }
    },
    methods: {
        setDisabled(row) {
            if (this.srcKey && row) {
                const src = row[this.srcKey]
                return !src || this.exclude.some(k => src.indexOf(k) > -1)
            }
            return false
        }
    }
}
</script>
  
<style lang="scss" scoped></style>
  